<div class="panel_grid p-1 w-full">
  <ng-content select="[cards]" />
</div>
